export enum TooltipPlacementEnum {
  Right = 'right',
  Top = 'top',
  Left = 'left',
  Bottom = 'bottom',
}
